import { c as _c } from "react/compiler-runtime";
import { FormSelectDataType, ListLoader, ListOptionsProps, ListOptionsWrapper, MAX_PANEL_HEIGHT, renderOption } from '@systemeio/ui';
import { useState } from 'react';
export interface ListOptionsAsyncProps extends ListOptionsProps {
  isFetching?: boolean;
  moreItems?: number;
}
export function ListOptionsAsync(t0) {
  const $ = _c(26);
  let asOption;
  let asOptions;
  let data;
  let isFetching;
  let loaderClassName;
  let loaderWrapperClassName;
  let optionProps;
  let optionsClassName;
  if ($[0] !== t0) {
    const {
      isFetching: t1,
      optionsClassName: t2,
      data: t3,
      loaderWrapperClassName: t4,
      loaderClassName: t5,
      moreItems,
      asOptions: t6,
      asOption: t7,
      ...t8
    } = t0;
    isFetching = t1;
    optionsClassName = t2;
    data = t3;
    loaderWrapperClassName = t4;
    loaderClassName = t5;
    asOptions = t6;
    asOption = t7;
    optionProps = t8;
    $[0] = t0;
    $[1] = asOption;
    $[2] = asOptions;
    $[3] = data;
    $[4] = isFetching;
    $[5] = loaderClassName;
    $[6] = loaderWrapperClassName;
    $[7] = optionProps;
    $[8] = optionsClassName;
  } else {
    asOption = $[1];
    asOptions = $[2];
    data = $[3];
    isFetching = $[4];
    loaderClassName = $[5];
    loaderWrapperClassName = $[6];
    optionProps = $[7];
    optionsClassName = $[8];
  }
  const [listRef, setListRef] = useState(null);
  let height;
  if ($[9] !== data || $[10] !== isFetching || $[11] !== listRef) {
    height = 0;
    if (listRef) {
      const options = listRef.querySelectorAll("[role=\"option\"]");
      options.forEach(option => {
        height = height + option.getBoundingClientRect().height;
        height;
      });
      height = data && !isFetching ? Math.min(height, MAX_PANEL_HEIGHT) || MAX_PANEL_HEIGHT : 42;
    }
    $[9] = data;
    $[10] = isFetching;
    $[11] = listRef;
    $[12] = height;
  } else {
    height = $[12];
  }
  let t1;
  if ($[13] !== height) {
    t1 = {
      height
    };
    $[13] = height;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  let t2;
  if ($[15] !== asOption || $[16] !== isFetching || $[17] !== loaderClassName || $[18] !== loaderWrapperClassName || $[19] !== optionProps) {
    t2 = t3 => {
      const {
        option: item
      } = t3;
      if (isFetching) {
        return <ListLoader loaderWrapperClassName={loaderWrapperClassName} loaderClassName={loaderClassName} />;
      }
      return renderOption({
        as: asOption,
        item,
        ...optionProps
      });
    };
    $[15] = asOption;
    $[16] = isFetching;
    $[17] = loaderClassName;
    $[18] = loaderWrapperClassName;
    $[19] = optionProps;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  let t3;
  if ($[21] !== asOptions || $[22] !== optionsClassName || $[23] !== t1 || $[24] !== t2) {
    t3 = <ListOptionsWrapper as={asOptions} ref={setListRef} optionsClassName={optionsClassName} style={t1}>{t2}</ListOptionsWrapper>;
    $[21] = asOptions;
    $[22] = optionsClassName;
    $[23] = t1;
    $[24] = t2;
    $[25] = t3;
  } else {
    t3 = $[25];
  }
  return t3;
}